// extracted by mini-css-extract-plugin
module.exports = {"CompletionFailed":"CompletionFailed_CompletionFailed__cdr_k","CompletionFailed__ErrorMessage":"CompletionFailed_CompletionFailed__ErrorMessage__cTLgM"};